import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { StyleSheet } from "react-native";
import { NativeSafeAreaProvider as NativeSafeAreaProviderHost, providerEventToMetrics } from "../platform/safe-area";
function NativeSafeAreaProvider(param) {
  var { children, style, onInsetsChange } = param;
  var handleInsetsChange = React.useCallback(function(param2) {
    var { nativeEvent } = param2;
    onInsetsChange({
      nativeEvent: providerEventToMetrics(nativeEvent)
    });
  }, [
    onInsetsChange
  ]);
  return /* @__PURE__ */ _jsx(NativeSafeAreaProviderHost, {
    style: [
      styles.fill,
      style
    ],
    onNativeInsetsChange: handleInsetsChange,
    children
  });
}
var styles = StyleSheet.create({
  fill: {
    flex: 1
  }
});
export {
  NativeSafeAreaProvider
};
//# sourceMappingURL=NativeSafeAreaProvider.native.js.map
